import { BcFieldProps } from "../../../interface/props/bcfield";
import { BCInput, BCInputCont } from "../../../styled/global.styled";
const NumberField = ({ field, register, isRequired, errors }: BcFieldProps) => (
  <BCInputCont className="bc-form-field">
    <BCInput
      className="bc-input"
      placeholder={field.placeholder}
      aria-label={field.label}
      id={field.item}
      type={field.type}
      {...register(field.item, { required: isRequired, valueAsNumber: true })}
    />
    <label htmlFor={field.item}>{field.label}</label>
    {errors && <span>Help Text</span>}
  </BCInputCont>
);

export default NumberField;
